/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Shift_Event_BackwardInputs */



/**
* | output |
* | --- |
* | "Shift the selected event(s) backward by one frame" |
*
* @param {Shortcut_Keys_Desc_Shift_Event_BackwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_shift_event_backward = /** @type {((inputs?: Shortcut_Keys_Desc_Shift_Event_BackwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Shift_Event_BackwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decaler les evenements selectionnes d'une image vers l'arriere")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschiebe das/die ausgewählte(n) Ereignis(se) um ein Frame nach hinten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta indietro di un fotogramma gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сдвинуть выбранное событие (события) назад на один кадр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazar el evento(s) seleccionado(s) hacia atrás un cuadro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将选定的事件向后移动一帧。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを1フレーム後ろにシフトします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटना(ओं) को एक फ्रेम पीछे खिसकाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desloque o(s) evento(s) selecionado(s) para trás em um quadro.")
	return /** @type {LocalizedString} */ ("Shift the selected event(s) backward by one frame")
});